import { useGetLocationQuery } from "AppQuries/master/Location/location";
import {
  formatOption2,
  formatOptions,
  formatOptionString,
} from "./optionsFormatter";
import { useGetPassTypeQuery } from "AppQuries/master/PassType/pass-type";
import { useRaceQuery } from "AppQuries/master/Race/get-all-race";
import { useGetNationalitiesQuery } from "AppQuries/master/Nationality/nationality";
import { useCpfTypesQuery } from "AppQuries/master/CpfType/get-all-cpf-types";
import { useResidentialsQuery } from "AppQuries/master/ResidentialType/get-all-residential-type";
import { useCPFContributionQuery } from "AppQuries/master/CpfContribution/contributions";
import { useCountriesQuery } from "AppQuries/master/Country/get-all-countries";
import { useGetAllPaymodeQuery } from "AppQuries/master/Paymode/get-all-paymodes";
import { useGetBanksQuery } from "AppQuries/master/Bank/bank";
import { useGetProjectsQuery } from "AppQuries/project/project";
import { useGetWorkingDayTypesQuery } from "AppQuries/master/working-days-type";
import { useGetAcademicsQuery } from "AppQuries/master/Academic/acadamics";
import { useGetTradesQuery } from "AppQuries/master/trade";
import { useGetMOMTradesQuery } from "AppQuries/master/mom-trade";
import { useGetAdditionsQuery } from "AppQuries/payroll/addition/get-all-additions";
import { useGetDeductionsQuery } from "AppQuries/payroll/deduction/get-all-deduction";
import { useGetVisaTypesQuery } from "AppQuries/master/visa-type";
import { useVehicleTypeCategoriesQuery } from "AppQuries/master/VehicleType/vehicletype";
import { useGetVehicleCategoriesQuery } from "AppQuries/master/vehicle-category";
import { useGetUserCompaniesQuery } from "AppQuries/setting/company-settings";
import { useGetLevyTypesQuery } from "AppQuries/master/Levy/levy-type";
import { useGetLevyAmountTypesQuery } from "AppQuries/master/Levy/levy-amount-type";
import { useGetAllUserMasterQuery } from "AppQuries/user/user-master";
import { useGetShiftTypesQuery } from "AppQuries/shift/type/shift-type";
import { useGetForeignerLevyTypesQuery } from "AppQuries/master/Levy/foreigner-levy-type";
import { useGetAllShiftPoliciesQuery } from "AppQuries/shift/policy/shift-policy";
import { useGetAllEmailModulesQuery } from "AppQuries/setting/email-alert-config";
import { useGetAllLeaveTypesQuery } from "AppQuries/leave/leave-types";
import { useGetCompanyListForClientQuery } from "AppQuries/company/get-company";

export function useFormattedCompanyOption({ userId }) {
  const { data } = useGetUserCompaniesQuery({ userId });
  
  const options = formatOption2(data, "companyName", "companyCode");
  return options;
}

export function useFormattedLocaionOption(companyCode) {
  const { data } = useGetLocationQuery({ companyCode });

  const options = formatOptions(data, "locationName", "locationCode");
  return options;
}

export function useFormattedNationalOption(companyCode) {
  const { data } = useGetNationalitiesQuery({
    companyCode: companyCode,
    isTrue: true,
  });

  const options = formatOptions(data, "description", "description");
  return options;
}

export function useFormattedPassTypeOption(companyCode) {
  const { data } = useGetPassTypeQuery({
    companyCode: companyCode,
    isTrue: true,
  });

  const options = formatOptions(data, "passName", "passCode");
  return options;
}

export function useFormattedRaceOption(companyCode) {
  const { data: races } = useRaceQuery({ companyCode });

  const options = formatOptions(races?.data, "description", "description");
  return options;
}

export function useFormattedVisaOption(companyCode) {
  const { data } = useGetVisaTypesQuery({ companyCode });

  const options = formatOptions(data, "description", "code");

  return options;
}

export function useFormattedCountryeOption(companyCode) {
  const { data } = useCountriesQuery({ companyCode });

  const options = formatOptions(data?.data, "country", "countryCode");
  return options;
}

export function useFormattedaAcadamicsOption(companyCode) {
  const { data } = useGetAcademicsQuery({ companyCode });

  const options = formatOptions(data?.data, "description", "code");
  return options;
}

// CPF Section Start

export function useFormattedResidentialTypeOption(companyCode) {
  const { data } = useResidentialsQuery({ companyCode });

  const options = formatOptions(data?.data, "description", "shortCode");
  return options;
}

export function useFormattedCPFTypeOption(companyCode) {
  const { data } = useCpfTypesQuery({ companyCode });

  const options = formatOptions(data?.data, "description", "shortCode");
  return options;
}

export function useFormattedCPFContributionOption(companyCode) {
  const { data: contributionData } = useCPFContributionQuery({ companyCode });

  const options = formatOptions(
    contributionData?.data,
    "contributionName",
    "contributionCode"
  );
  return options;
}

// CPF Section End

// Bank Section Start

export function useFormattedPaymodeOption(companyCode) {
  const { data } = useGetAllPaymodeQuery({ companyCode });

  const options = formatOptions(data?.data, "paymentMode", "paymentCode");
  return options;
}

export function useFormattedBankOption(companyCode) {
  const { data } = useGetBanksQuery({ companyCode: companyCode, isTrue: true });

  const options = formatOptions(data, "bankName", "id");
  return options;
}

// Bank Section End

// Employee Section Start
export function useFormattedTradeOption(companyCode) {
  const { data } = useGetTradesQuery({
    companyCode: companyCode,
    isTrue: true,
  });

  const options = formatOptionString(data, "tradeName", "code");
  return options;
}
export function useFormattedMomTradeOption(companyCode) {
  const { data } = useGetMOMTradesQuery({
    companyCode: companyCode,
    isTrue: true,
  });

  const options = formatOptionString(data, "tradeName", "code");
  return options;
}
// Emploee Section End

export function useFormattedProjectOption({ companyCode, locationCode = "" }) {
  const { data } = useGetProjectsQuery({
    companyCode: companyCode,
    locationCode: locationCode,
    isTrue: true,
  });

  const options = formatOptions(data, "projectName", "projectCode");
  return options;
}

export function useFormattedWorkingDaysTypeOption(companyCode) {
  const { data } = useGetWorkingDayTypesQuery({
    companyCode: companyCode,
    isTrue: true,
  });

  const options = formatOptions(data, "typeName", "code");
  return options;
}

export function useFormattedAllowanceOption(companyCode) {
  const { data } = useGetAdditionsQuery({
    companyCode: companyCode,
    isTrue: true,
  });

  const options = formatOption2(data?.data, "description", "code");
  return options;
}

export function useFormattedDeductionOption(companyCode) {
  const { data } = useGetDeductionsQuery({
    companyCode: companyCode,
    isTrue: true,
  });

  const options = formatOption2(data?.data, "description", "code");
  return options;
}

export function useFormattedVehicleTypeOption(companyCode) {
  const { data } = useVehicleTypeCategoriesQuery({
    companyCode: companyCode,
    isTrue: true,
  });

  const options = formatOptions(data, "name", "vehicleTypeID");
  return options;
}

export function useFormattedVehicleCategoryOption(companyCode) {
  const { data } = useGetVehicleCategoriesQuery({
    companyCode: companyCode,
    isTrue: true,
  });

  const options = formatOptions(data, "categoryName", "vehicleCategoryID");
  return options;
}

export function useFormattedLevyTypesOption(companyCode) {
  const { data } = useGetLevyTypesQuery({
    companyCode: companyCode,

    isTrue: true,
  });

  const options = formatOptions(data, "description", "code");
  return options;
}

export function useFormattedForeginerLevyTypesOption(companyCode) {
  const { data } = useGetForeignerLevyTypesQuery({
    companyCode: companyCode,

    isTrue: true,
  });

  const options = formatOptions(data, "description", "code");
  return options;
}

export function useFormattedLevyAmountTypesOption(companyCode) {
  const { data } = useGetLevyAmountTypesQuery({
    companyCode: companyCode,
    isTrue: true,
  });

  const options = formatOptions(data, "levyAmountTypeName", "levyAmountTypeID");
  return options;
}

export function useFormattedUserListOption({ companyCode, locationCode }) {
  const { data } = useGetAllUserMasterQuery({
    companyCode: companyCode,
    locationCode: locationCode,
  });

  const options = formatOptions(data, "userName", "userID");
  return options;
}

export function useFormattedShiftTypeOption(companyCode) {
  const { data } = useGetShiftTypesQuery({
    companyCode: companyCode,
  });

  const options = formatOption2(data, "shiftTypeName", "shiftTypeID");

  return options;
}

export function useFormattedShiftPolicyOption({ companyCode, locationCode }) {
  const { data } = useGetAllShiftPoliciesQuery({
    companyCode: companyCode,
    locationCode: locationCode,
  });

  const updatedData = data?.map((item) => ({
    ...item,
    shiftName: `${item.shiftName} (${item.locationCode})`,
  }));
  const options = formatOption2(updatedData, "shiftName", "shiftPolicyID");

  return options;
}

export function useFormattedShiftPolicyOption2({ companyCode, locationCode }) {
  const { data } = useGetAllShiftPoliciesQuery({
    companyCode: companyCode,
    locationCode: locationCode,
  });

  const options = formatOption2(data, "shiftName", "shiftPolicyID");

  return options;
}

export function useFormattedEmailModuleListOption(companyCode) {
  const { data } = useGetAllEmailModulesQuery({
    companyCode: companyCode,
  });

  const options = formatOption2(data, "modules", "modules");

  return options;
}

export function useFormattedLeaveTypesOption(companyCode) {
  const { data } = useGetAllLeaveTypesQuery({
    companyCode: companyCode,
    isTrue: true,
  });
  
  const options = formatOptions(data?.data || [], "leaveName", "leaveCode");

  return options;
}

export function useFormattedCompanyListForClientOption(companyCode) {
  const { data } = useGetCompanyListForClientQuery({
    companyCode: companyCode,
  });

  const options = formatOption2(data, "companyName", "companyCode");

  return options;
}
